import { ChangeGeneratedPasswordService } from './change-generated-password.service';
import { HolidayService } from './holiday.service';
import { LeaveSchedulesService } from './leave-schedules.service';
import { LegalDaysOffService } from './legal-day-off.service';

export { ChangeGeneratedPasswordService, HolidayService, LeaveSchedulesService, LegalDaysOffService };

export const SERVICES = [];
